var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
import React from "react";
import TxnSuccess from "@frameworks/shared-library/assets/images/SalesJourney/txn-success.svg";
import TxnFailed from "@frameworks/shared-library/assets/images/SalesJourney/txn-failure.svg";
import BrokenPage from "@frameworks/shared-library/assets/images/SalesJourney/broken-page.svg";
import NotAllowed from "@frameworks/shared-library/assets/images/SalesJourney/not-allowed.svg";
import regClient from "@frameworks/shared-library/assets/images/SalesJourney/regClientError.svg";
import PauseSuccess from "@frameworks/shared-library/assets/images/SalesJourney/pause-success.svg";
import { EValueType, } from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
import { EHoldingType, } from "@domains/features/TOCJourney/entities/MFPurchaseOrderEntity";
import moment from "moment";
import black from "@frameworks/shared-library/assets/images/ClientTiers/black-clienttier.svg";
import blue from "@frameworks/shared-library/assets/images/ClientTiers/blue-clienttier.svg";
import bronze from "@frameworks/shared-library/assets/images/ClientTiers/bronze-clienttier.svg";
import diamond from "@frameworks/shared-library/assets/images/ClientTiers/diamond-clienttier.svg";
import gold from "@frameworks/shared-library/assets/images/ClientTiers/gold-clienttier.svg";
import platinum from "@frameworks/shared-library/assets/images/ClientTiers/platinum-clienttier.svg";
import silver from "@frameworks/shared-library/assets/images/ClientTiers/silver-clienttier.svg";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import { ETransferFundsSortOrder, ETransferFundsSortColumns, } from "@domains/features/TOCJourney/entities/MFSwitchDetailsEntity";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import { EMFFilterType, } from "@domains/features/Markets/MutualFunds/entities/MutualFundsSchemesEntity";
import { ETransactionType } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import { numberWithSuffix } from "@domains/utils/numberMethods";
// Adding only common frequency values here to pull the order details from response.
// STP, SWP has default frequency as `MONTHLY`
export var ETransactionFrequency;
(function (ETransactionFrequency) {
    ETransactionFrequency["MONTHLY"] = "MONTHLY";
})(ETransactionFrequency || (ETransactionFrequency = {}));
export var EMandateType;
(function (EMandateType) {
    EMandateType["PHYSICAL"] = "X";
    EMandateType["EMANDATE"] = "N";
})(EMandateType || (EMandateType = {}));
export var EErrorCodes;
(function (EErrorCodes) {
    EErrorCodes["ER1014"] = "ER1014";
})(EErrorCodes || (EErrorCodes = {}));
var EFrequency;
(function (EFrequency) {
    EFrequency["DAILY"] = "daily";
    EFrequency["YEARLY"] = "yearly";
    EFrequency["MONTHLY"] = "monthly";
    EFrequency["QUARTERLY"] = "quarterly";
})(EFrequency || (EFrequency = {}));
var getNumberDaysAndMonths = function (fre) {
    switch (fre.toLowerCase()) {
        case EFrequency.DAILY:
            return 1;
        case EFrequency.YEARLY:
            return 12;
        case EFrequency.MONTHLY:
            return 1;
        case EFrequency.QUARTERLY:
            return 3;
        default:
            return 0;
    }
};
export var EInvestmentType;
(function (EInvestmentType) {
    EInvestmentType["SIP"] = "SIP";
    EInvestmentType["LUMPSUM"] = "Lumpsum";
    EInvestmentType["SWITCH"] = "Switch";
    EInvestmentType["STP"] = "STP";
    EInvestmentType["CANCEL"] = "Cancel";
    EInvestmentType["PAUSE"] = "Pause";
    EInvestmentType["SWP"] = "SWP";
    EInvestmentType["REDEEM"] = "REDEEM";
    EInvestmentType["MODIFY_ORDER"] = "Modify";
    EInvestmentType["RESUME"] = "Resume";
})(EInvestmentType || (EInvestmentType = {}));
// This enum is used for Transaction type to Investment type while placing an order
export var trxTypeToInvTypeMapping = (_a = {},
    _a[ETransactionType.SIP] = EInvestmentType.SIP,
    _a[ETransactionType.LUMPSUM] = EInvestmentType.LUMPSUM,
    _a[ETransactionType.REDEEM] = EInvestmentType.REDEEM,
    _a[ETransactionType.SWP] = EInvestmentType.SWP,
    _a[ETransactionType.STP] = EInvestmentType.STP,
    _a[ETransactionType.SWITCH] = EInvestmentType.SWITCH,
    _a);
export var ESourcePage;
(function (ESourcePage) {
    ESourcePage["PRODUCT_PAGE"] = "PRODUCT-PAGE";
})(ESourcePage || (ESourcePage = {}));
export var EReedemType;
(function (EReedemType) {
    EReedemType["DEMAT"] = "Demat";
    EReedemType["PHYSICAL"] = "Physical";
})(EReedemType || (EReedemType = {}));
export var minAmount = {
    sipMin: 500,
    lumsumMin: 5000,
};
export var subscriptionRoute = "subscribe-popup";
export var firstInstallmentConstentEnum;
(function (firstInstallmentConstentEnum) {
    firstInstallmentConstentEnum["NOW"] = "Y";
    firstInstallmentConstentEnum["LATER"] = "N";
})(firstInstallmentConstentEnum || (firstInstallmentConstentEnum = {}));
export var MutualFundInvestment = [
    { title: "SIP", value: EInvestmentType.SIP, rank: 1 },
    { title: "Lumpsum", value: EInvestmentType.LUMPSUM, rank: 2 },
];
export var RedeemTypes = [
    { title: "Demat", value: EReedemType.DEMAT, rank: 1 },
    { title: "Physical", value: EReedemType.PHYSICAL, rank: 2 },
];
export var SipFrequency = [
    { title: "Weekly", value: "Weekly" },
    { title: "Fortnightly", value: "Fortnightly" },
    { title: "Monthly", value: "Monthly" },
    { title: "Quarterly", value: "Quarterly" },
];
export var firstInstallmentConstent = [
    { title: "Today", value: firstInstallmentConstentEnum.NOW, rank: 1 },
    { title: "Later", value: firstInstallmentConstentEnum.LATER, rank: 2 },
];
export var validityRadioEnum;
(function (validityRadioEnum) {
    validityRadioEnum["UNTIL_CANCELLED"] = "999";
    validityRadioEnum["YEAR_10"] = "120";
    validityRadioEnum["YEAR_8"] = "96";
    validityRadioEnum["YEAR_5"] = "60";
    validityRadioEnum["YEAR_3"] = "36";
    validityRadioEnum["YEAR_2"] = "24";
    validityRadioEnum["YEAR_1"] = "12";
    validityRadioEnum["MONTH_9"] = "9";
    validityRadioEnum["MONTH_6"] = "6";
    validityRadioEnum["CUSTOME"] = "custom";
})(validityRadioEnum || (validityRadioEnum = {}));
export var mandateTypeRadioList = [
    { value: EMandateType.EMANDATE, display: "e-Mandate" },
    { value: EMandateType.PHYSICAL, display: "Physical Mandate" },
];
export var mandateMinAmt = {
    X: 50000,
    N: 50000,
};
export var mandateMaxAmt = {
    X: 10000000,
    N: 10000000,
};
export var schemeErrors = {
    bank: "There was some trouble in fetching bank details. Please retry after some time from orderbook",
    payment: "The above bank account selected is not supported by BSE StAR MF payment gateway. Kindly contact your RM for further assistance.",
    purchase: "This scheme is not available for purchase.",
    redeem: "You do not have any units to redeem on this scheme. Please select a scheme from your holdings to redeem.",
};
export var StatusTitle = {
    failed: "Payment Failed",
    success: "Payment Successful",
    pending: "Awaiting Payment Confirmation",
};
export var OrderStatusTitle = {
    failed: "Order Placement Unsuccessful",
    success: "Order Successfully Placed",
    cancelSuccess: "SIP cancellation request has been successfully submitted.",
    pending: "Order Pending",
    orderReject: "Order Rejected",
    pauseSuccess: "Order Paused Successfully",
};
export var StatusIcon = {
    failed: "edel-icon-rounded-close",
    success: "edel-icon-success",
    pending: "edel-icon-pending",
};
export var MfStatus;
(function (MfStatus) {
    MfStatus["FAILED"] = "failed";
    MfStatus["SUCCESS"] = "success";
    MfStatus["PENDING"] = "pending";
})(MfStatus || (MfStatus = {}));
export var returnType;
(function (returnType) {
    returnType["GROWTH"] = "Growth";
    returnType["DIVIDEND"] = "Dividend-Payout";
    returnType["REINVEST"] = "Dividend-Reinvest";
})(returnType || (returnType = {}));
export var MFStatusDisplay = (_b = {},
    _b[EInvestmentType.LUMPSUM] = (_c = {},
        _c[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "A consent link will be shared with the client. The payment can be done once the client accepts the consent.",
            icon: TxnSuccess,
        },
        _c[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "We couldn’t place your order right now. Please try again shortly.",
            icon: TxnFailed,
        },
        _c),
    _b[EInvestmentType.SIP] = (_d = {},
        _d[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "A consent link will be shared with the client. The payment can be done once the client accepts the consent.",
            icon: TxnSuccess,
        },
        _d[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "We couldn’t place your order right now. Please try again shortly.",
            icon: TxnFailed,
        },
        _d),
    _b[EInvestmentType.REDEEM] = (_e = {},
        _e[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "You’ll receive a confirmation once the process is complete.",
            icon: TxnSuccess,
            subDescription: "The amount will vary based on the NAV at the time of redemption, and the units will be redeemed accordingly.",
        },
        _e[MfStatus.FAILED] = {
            title: OrderStatusTitle.orderReject,
            description: "Your Redeem request couldn't be processed. Please check the details and try again.",
            icon: TxnFailed,
        },
        _e),
    _b[EInvestmentType.CANCEL] = (_f = {},
        _f[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.cancelSuccess,
            description: "You will receive a confirmation once it has been processed.",
            icon: TxnSuccess,
        },
        _f[MfStatus.FAILED] = {
            title: OrderStatusTitle.orderReject,
            description: "Your Cancel request couldn't be processed. Please check the details and try again.",
            icon: TxnFailed,
        },
        _f),
    _b[EInvestmentType.PAUSE] = (_g = {},
        _g[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.pauseSuccess,
            description: "",
            icon: PauseSuccess,
        },
        _g[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "",
            icon: TxnFailed,
        },
        _g),
    _b[EInvestmentType.RESUME] = (_h = {},
        _h[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "Your resume request has been successfully submitted.",
            icon: TxnSuccess,
        },
        _h[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "Your resume request couldn't be processed. Please check the details and try again.",
            icon: TxnFailed,
        },
        _h),
    _b[EInvestmentType.SWP] = (_j = {},
        _j[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "You’ll receive a confirmation once the process is complete.",
            icon: TxnSuccess,
            subDescription: "The withdrawal amount will vary based on the NAV at the time of processing, and the units will be deducted accordingly.",
        },
        _j[MfStatus.FAILED] = {
            title: OrderStatusTitle.orderReject,
            description: "Your SWP request couldn't be processed. Please check the details and try again.",
            icon: TxnFailed,
        },
        _j),
    _b[EInvestmentType.SWITCH] = (_k = {},
        _k[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "You’ll receive a confirmation once the process is complete.",
            icon: TxnSuccess,
            subDescription: "The switch amount will be determined based on the NAV at the time of execution, and the respective units will be transferred accordingly.",
        },
        _k[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "Your Switch request couldn't be processed. Please check the details and try again.",
            icon: TxnFailed,
        },
        _k),
    _b[EInvestmentType.STP] = (_l = {},
        _l[MfStatus.SUCCESS] = {
            title: OrderStatusTitle.success,
            description: "You’ll receive a confirmation once the process is complete.",
            icon: TxnSuccess,
            subDescription: "The transfer amount will depend on the NAV at the time of execution, and the units will be moved accordingly.",
        },
        _l[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "",
            icon: TxnFailed,
        },
        _l),
    _b[EInvestmentType.MODIFY_ORDER] = (_m = {},
        _m[MfStatus.SUCCESS] = {
            title: "Order successfully Modified",
            icon: TxnSuccess,
        },
        _m[MfStatus.FAILED] = {
            title: OrderStatusTitle.failed,
            description: "We couldn’t place your order right now. Please try again shortly.",
            icon: TxnFailed,
        },
        _m),
    _b);
export var HoldingError = (_o = {},
    _o[EInvestmentType.STP] = {
        icon: NotAllowed,
        title: "STP Order Not Allowed",
        description: "Please select a Physically held scheme to initate a Systematic Transfer Plan.",
    },
    _o[EInvestmentType.SWP] = {
        icon: NotAllowed,
        title: "SWP Order Not Allowed",
        description: "SWP unavailable for this scheme-holding type combination.",
    },
    _o[EInvestmentType.SWITCH] = {
        icon: NotAllowed,
        title: "Switch Order Not Allowed",
        description: "The selected Switch-out scheme is incompatible with selected holding type",
    },
    _o[EInvestmentType.REDEEM] = {
        icon: NotAllowed,
        title: "Redemption not Allowed",
        description: "Client does not have holdings in this scheme for Redemption.",
    },
    _o);
export var MFError = {
    Error: {
        icon: BrokenPage,
        title: "Something went wrong",
        description: "Try refreshing  page, or try again later",
    },
    noData: {
        icon: NotAllowed,
        title: "Scheme is not available!",
        description: "Mutual Fund is not available! Try again later.",
    },
    physicalNotAllowed: {
        icon: NotAllowed,
        title: "The client only has Demat Mutual fund segment enabled.",
        description: "They are not eligible to invest in Mutual fund with Physical holding type. Assist in enabling Physical segment to proceed.",
    },
    dematNotAllowed: {
        icon: NotAllowed,
        title: "The client only has Physical Mutual fund segment enabled.",
        description: "They are not eligible to invest in Mutual fund with Demat holding type. Assist in enabling Demat segment to proceed..",
    },
    stpNotAllowed: {
        icon: NotAllowed,
        title: "STP Order Not Allowed",
        description: "This scheme does not support Systematic Transfer Plans.",
    },
    swpNotAllowed: {
        icon: NotAllowed,
        title: "SWP Order Not Allowed",
        description: "This scheme does not support Systematic Withdrawal Plans.",
    },
    switchNotAllowed: {
        icon: NotAllowed,
        title: "Switch Order Not Allowed",
        description: "This scheme is not eligible for switch transactions.",
    },
    directNotAllowed: {
        icon: NotAllowed,
        title: "Direct Mutual Fund is not allowed for the client",
        description: "They are not eligible to invest in Direct Mutual Fund.",
    },
    notAllowedFolio: function (investmentType) {
        return {
            icon: NotAllowed,
            title: "".concat(investmentType, " order is not allowed"),
            description: "".concat(investmentType, " order is not allowed for this folio. Please try again with another folio."),
            rightBtn: "Close",
            leftBtn: "Go Back",
        };
    },
    txnTypeNotAllowed: function (investmentType) {
        return {
            icon: NotAllowed,
            title: "".concat(capitalizeFirstLetter(investmentType), " order is not allowed"),
            description: "This mutual fund currently cannot be ".concat([EInvestmentType.REDEEM, EInvestmentType.SWP].includes(investmentType)
                ? "redeemed"
                : "transferred", ". Please try again with another mutual fund."),
            rightBtn: "Close",
            leftBtn: "Go Back",
        };
    },
    noHoldingsType: {
        icon: NotAllowed,
        title: "The selected client is not allowed to place a Mutual Fund order",
        description: "Please ask the client to upgrade to an Investment/ Equity account for successful MF order placement.",
    },
    regAccount: {
        icon: regClient,
        title: "The client currently has only a Registered Account",
        description: "They are not yet eligible to invest in Mutual Funds. Assist in opening an investment account to proceed.",
    },
    noPhysicalHoldings: {
        icon: NotAllowed,
        title: "No Physical Holdings Found",
        description: "Client does not have physical holdings in this scheme.",
    },
    noAvailableHoldings: {
        icon: NotAllowed,
        title: "No Holdings Found",
        description: "Client does not have holdings in this scheme.",
    },
};
export var OrderDetailsDisplay = function (investmentType, purchaseData, mfData, switchData, externalData, isError, isModify) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    if (isModify === void 0) { isModify = false; }
    if (isModify) {
        // add new switch statement here for lumpsum,sip,redeem
        switch (investmentType) {
            case EInvestmentType.SIP:
                return [
                    [
                        {
                            label: "Next SIP Instalment amount",
                            value: Number(purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amt),
                            valueType: EValueType.CURRENCY,
                        },
                        {
                            label: "New SIP Date",
                            value: moment(purchaseData.startDt).format("DD MMM YYYY"),
                        },
                        {
                            label: "New Mandate",
                            value: purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.mandateId,
                        },
                    ],
                    __spreadArray(__spreadArray(__spreadArray([
                        {
                            label: "Investment Type",
                            value: investmentType,
                        },
                        {
                            label: "SIP Frequency",
                            value: purchaseData.frequency,
                        },
                        {
                            label: "SIP Day",
                            value: numberWithSuffix(Number(purchaseData.startDay)),
                        },
                        {
                            label: "Return Option",
                            value: mfData.returnType,
                        }
                    ], __read((mfData.returnType !== returnType.GROWTH
                        ? [
                            {
                                label: "Div Frequency",
                                value: mfData.divFreq,
                            },
                        ]
                        : [])), false), [
                        {
                            label: "Holding Type",
                            value: purchaseData.physicalFlag === EHoldingType.Demat
                                ? "Demat"
                                : "Physical",
                        }
                    ], false), __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: ((_a = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _a === void 0 ? void 0 : _a.dpOrderNum)
                                    ? (_b = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _b === void 0 ? void 0 : _b.dpOrderNum
                                    : (_c = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _c === void 0 ? void 0 : _c.orderNum,
                            },
                        ])), false),
                ];
            case EInvestmentType.LUMPSUM:
                return [
                    [
                        {
                            label: "Next Lumpsum Amount",
                            value: Number(purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amt),
                            valueType: EValueType.CURRENCY,
                        },
                    ],
                    __spreadArray(__spreadArray(__spreadArray([
                        {
                            label: "Investment Type",
                            value: investmentType,
                        },
                        {
                            label: "Return Option",
                            value: mfData.returnType,
                        }
                    ], __read((mfData.returnType !== returnType.GROWTH
                        ? [
                            {
                                label: "Div Frequency",
                                value: mfData.divFreq,
                            },
                        ]
                        : [])), false), [
                        {
                            label: "Holding Type",
                            value: purchaseData.physicalFlag === EHoldingType.Demat
                                ? "Demat"
                                : "Physical",
                        }
                    ], false), __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: ((_d = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _d === void 0 ? void 0 : _d.dpOrderNum)
                                    ? (_e = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _e === void 0 ? void 0 : _e.dpOrderNum
                                    : (_f = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _f === void 0 ? void 0 : _f.orderNum,
                            },
                        ])), false),
                ];
            case EInvestmentType.REDEEM:
                return [
                    [
                        {
                            label: "Next Redeem Amount",
                            value: Number(purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amt),
                            valueType: EValueType.CURRENCY,
                        },
                    ],
                    __spreadArray([
                        {
                            label: "Investment Type",
                            value: investmentType,
                        },
                        {
                            label: "Holding Type",
                            value: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.physicalFlag) === EHoldingType.Demat
                                ? "Demat"
                                : "Physical",
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: ((_g = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _g === void 0 ? void 0 : _g.dpOrderNum)
                                    ? (_h = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _h === void 0 ? void 0 : _h.dpOrderNum
                                    : (_j = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _j === void 0 ? void 0 : _j.orderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean((_k = externalData === null || externalData === void 0 ? void 0 : externalData.data) === null || _k === void 0 ? void 0 : _k.dpOrderNum),
                            },
                        ])), false),
                ];
        }
    }
    else {
        switch (investmentType) {
            case EInvestmentType.LUMPSUM:
                return [
                    [
                        {
                            label: "Lumpsum Amount",
                            value: purchaseData.amt,
                            valueType: EValueType.CURRENCY,
                        },
                    ],
                    __spreadArray([
                        {
                            label: "Investment Type",
                            value: "Lumpsum",
                        },
                        {
                            label: "Return Option",
                            value: mfData.returnType,
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum),
                            },
                        ])), false),
                ];
            case EInvestmentType.SIP:
                return [
                    [
                        {
                            label: "SIP Instalment amount",
                            value: purchaseData.amt,
                            valueType: EValueType.CURRENCY,
                        },
                        purchaseData.generateToday === firstInstallmentConstentEnum.NOW && {
                            label: "First Installment",
                            value: "Today " + moment().format("DD MMM YYYY"),
                        },
                        {
                            label: "Next Installment",
                            value: moment(purchaseData.startDt).format("DD MMM YYYY"),
                        },
                    ],
                    __spreadArray(__spreadArray(__spreadArray([
                        {
                            label: "Investment Type",
                            value: "SIP",
                        },
                        {
                            label: "SIP Frequency",
                            value: purchaseData.frequency,
                        },
                        {
                            label: "SIP Day",
                            value: numberWithSuffix(Number(purchaseData.startDay)),
                        },
                        {
                            label: "Return Option",
                            value: mfData.returnType,
                        }
                    ], __read((mfData.returnType !== returnType.GROWTH
                        ? [
                            {
                                label: "Div Frequency",
                                value: mfData.divFreq,
                            },
                        ]
                        : [])), false), [
                        {
                            label: "Holding Type",
                            value: purchaseData.physicalFlag === EHoldingType.Demat
                                ? "Demat"
                                : "Physical",
                        }
                    ], false), __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum),
                            },
                        ])), false),
                ];
            case EInvestmentType.REDEEM:
                return [
                    __spreadArray([], __read((isError ? [] : [])), false),
                    __spreadArray([
                        {
                            label: "Redeem amount",
                            value: purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amt,
                            valueType: EValueType.CURRENCY,
                        },
                        {
                            label: "Holding Type",
                            value: (purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.physicalFlag) === EHoldingType.Demat
                                ? "Demat"
                                : "Physical",
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum),
                            },
                        ])), false),
                ];
            case EInvestmentType.SWITCH:
                return [
                    [],
                    __spreadArray([
                        {
                            label: "Switch Amount",
                            value: purchaseData.amt,
                            valueType: EValueType.CURRENCY,
                        },
                        {
                            label: "Switch from",
                            value: "".concat(mfData.schemeName),
                        },
                        {
                            label: "Switch to",
                            value: "".concat(switchData.schemeName),
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum),
                            },
                        ])), false),
                ];
            case EInvestmentType.CANCEL:
                return [
                    [],
                    __spreadArray([
                        {
                            label: "Fund Name",
                            value: "".concat((_l = externalData === null || externalData === void 0 ? void 0 : externalData.scheme) === null || _l === void 0 ? void 0 : _l.schemeName),
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.displayTransactionId,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.displayTransactionId),
                            },
                        ])), false),
                ];
            case EInvestmentType.PAUSE:
                return [
                    [
                        {
                            label: "Pause for",
                            value: "".concat((_m = mfData.sipData[externalData.modifyData.frequency]) === null || _m === void 0 ? void 0 : _m.pauseMaxInst, " months"),
                        },
                        {
                            label: (React.createElement("div", { className: "d-flex gap-1 align-items-center" },
                                "Next SIP Date",
                                React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "The Next SIP Date is the scheduled date when your SIP will resume after the pause period. If you wish to modify this, please check your SIP settings or contact your RM" }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("span", { className: "edel-icon-Information txt_secondary-gray d-flex" }) }))),
                            value: moment((_o = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _o === void 0 ? void 0 : _o.nextInstallmentDate).format("DD MMM YYYY"), // will come from api
                        },
                    ],
                    __spreadArray([
                        {
                            label: "Order Date",
                            value: moment((_p = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _p === void 0 ? void 0 : _p.orderDate).format("DD MMM YYYY"), //need values will come from api
                        },
                        {
                            label: "SIP Amount",
                            value: "".concat((_q = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _q === void 0 ? void 0 : _q.amount),
                        },
                        {
                            label: "Frequency",
                            value: "".concat((_r = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _r === void 0 ? void 0 : _r.frequency), //need values
                        },
                        {
                            label: "SIP Day",
                            value: "".concat((_s = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _s === void 0 ? void 0 : _s.displayStartDay), //need values
                        },
                        {
                            label: "Installments Paid",
                            value: "".concat((_t = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _t === void 0 ? void 0 : _t.totalInstallmentsCompleted), //need values
                        },
                        {
                            label: "Transaction Mode",
                            value: "".concat((_u = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _u === void 0 ? void 0 : _u.investmentType), //need values
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: (_v = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _v === void 0 ? void 0 : _v.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean((_w = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _w === void 0 ? void 0 : _w.dpOrderNum),
                            },
                        ])), false),
                ];
            case EInvestmentType.RESUME:
                return [
                    [
                        {
                            label: "Next SIP Date",
                            value: "".concat((_x = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _x === void 0 ? void 0 : _x.nextInstallmentDate),
                        },
                    ],
                    __spreadArray([
                        {
                            label: "Order Date",
                            value: moment((_y = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _y === void 0 ? void 0 : _y.orderDate).format("DD MMM YYYY"), //need values will come from api
                        },
                        {
                            label: "SIP Amount",
                            value: "".concat((_z = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _z === void 0 ? void 0 : _z.amount),
                        },
                        {
                            label: "Frequency",
                            value: "".concat((_0 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _0 === void 0 ? void 0 : _0.frequency), //need values
                        },
                        {
                            label: "SIP Day",
                            value: "".concat((_1 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _1 === void 0 ? void 0 : _1.displayStartDay), //need values
                        },
                        {
                            label: "Installments Paid",
                            value: "".concat((_2 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _2 === void 0 ? void 0 : _2.totalInstallmentsCompleted), //need values
                        },
                        {
                            label: "Transaction Mode",
                            value: "".concat((_3 = externalData === null || externalData === void 0 ? void 0 : externalData.modifyData) === null || _3 === void 0 ? void 0 : _3.investmentType), //need values
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: (_4 = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _4 === void 0 ? void 0 : _4.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean((_5 = externalData === null || externalData === void 0 ? void 0 : externalData.apiResponse) === null || _5 === void 0 ? void 0 : _5.dpOrderNum),
                            },
                        ])), false),
                ];
            case EInvestmentType.SWP:
                return [
                    [
                        {
                            label: "SWP amount",
                            value: purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.amt,
                            valueType: EValueType.CURRENCY,
                        },
                        {
                            label: "Number of withdrawals",
                            value: purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.installment, //need values
                        },
                    ],
                    __spreadArray([
                        {
                            label: "Withdrawal Date",
                            value: moment(purchaseData === null || purchaseData === void 0 ? void 0 : purchaseData.startDt).format("DD-MMM-YY"), //need values
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum),
                            },
                        ])), false),
                ];
                break;
            case EInvestmentType.STP:
                return [
                    [],
                    __spreadArray([
                        {
                            label: "Transfer amount",
                            value: purchaseData.amt,
                            valueType: EValueType.CURRENCY,
                        },
                        {
                            label: "Transfer from",
                            value: "".concat(purchaseData.schemeName), // need to add category and subcategory
                        },
                        {
                            label: "Transfer to",
                            value: "".concat(switchData.schemeName), // need to add category and subcategory
                        },
                        {
                            label: "Transfer date",
                            value: "".concat(purchaseData.startDt), // need value
                        },
                        {
                            label: "No of installments",
                            value: (_6 = purchaseData.installment) !== null && _6 !== void 0 ? _6 : "-",
                        }
                    ], __read((isError
                        ? []
                        : [
                            {
                                label: "Order ID",
                                value: externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum,
                                valueType: EValueType.TEXT,
                                copyValue: Boolean(externalData === null || externalData === void 0 ? void 0 : externalData.dpOrderNum),
                            },
                        ])), false),
                ];
            default:
                break;
        }
    }
};
export var validityRadio = [
    { value: validityRadioEnum.UNTIL_CANCELLED, display: "Until Cancelled" },
    { value: validityRadioEnum.YEAR_10, display: "120 (10 Years)" },
    { value: validityRadioEnum.YEAR_8, display: "96 (8 Years)" },
    { value: validityRadioEnum.YEAR_5, display: "60 (5 Years)" },
    { value: validityRadioEnum.YEAR_3, display: "36 (3 Years)" },
    { value: validityRadioEnum.YEAR_2, display: "24 (2 Years)" },
    { value: validityRadioEnum.YEAR_1, display: "12 (1 Years)" },
    { value: validityRadioEnum.MONTH_9, display: "9 (9 Months)" },
    { value: validityRadioEnum.MONTH_6, display: "6 (6 Months)" },
    { value: validityRadioEnum.CUSTOME, display: "Custom" },
];
export var MFInvestment = [{ title: "Lumpsum", value: "Lumpsum", rank: 1 }];
export var MFschemeType = [
    { title: "Regular", value: "Regular" },
    { title: "Direct", value: "Direct" },
];
export var MFReturnOption = [
    { title: "Growth", value: "Growth" },
    { title: "Div Payout", value: "DivPayout" },
    { title: "Div Reinv", value: "Div Reinv" },
];
export var MFDivFrequency = [
    { title: "Yearly", value: "Yearly" },
    { title: "Interim", value: "Interim" },
];
export var orderList = [
    { title: "Action", value: "Buy" },
    { title: "Product type", value: "F&O (NRML)" },
    { title: "Order type", value: "Market" },
    { title: "No of Lots", value: "2 (Qty: 100)" },
    { title: "Margin required", value: "14,806.75" },
    { title: "Available", value: "5,000.00" },
];
export var paymentstatusDetails = [
    { title: "Date and Time", value: "09-Jan-23, 23:18:27" },
    { title: "Amount", value: "100.00" },
    { title: "Account No", value: "05xxxxxxxx7" },
    { title: "Bank Name", value: "ICICI Bank Ltd" },
    { title: "UPI ID", value: "1092837465@paytm" },
    { title: "Scheme", value: "Nippon India Liquid Funds (G)" },
    { title: "Type", value: "SIP" },
    { title: "Return Option", value: "Growth" },
    { title: "SIP Type", value: "Perpetual" },
    { title: "Frequency", value: "Monthly" },
    { title: "Duration", value: "999" },
    { title: "SIP Date", value: "10-Jan-23" },
    { title: "Mandate ID", value: "130024556" },
    { title: "Order ID", value: "675467" },
];
export var Foliodropdown = [
    {
        title: "10923874-HDFC BANK LTD- N",
        value: "10923874-HDFC BANK LTD- N ...",
    },
    {
        title: "10923874-HDFC BANK LTD- N ...",
        value: "10923874-HDFC BANK LTD- N ...",
    },
];
export var ERedemptionMode;
(function (ERedemptionMode) {
    ERedemptionMode["PARTIAL"] = "Partial";
    ERedemptionMode["FULL"] = "Full";
})(ERedemptionMode || (ERedemptionMode = {}));
export var ERedemptionBy;
(function (ERedemptionBy) {
    ERedemptionBy["UNITS"] = "Units";
    ERedemptionBy["AMOUNT"] = "Amount";
})(ERedemptionBy || (ERedemptionBy = {}));
export var RedemptionMode = [
    { title: ERedemptionMode.PARTIAL, value: "Partial", rank: 1 },
    { title: ERedemptionMode.FULL, value: "Full", rank: 2 },
];
export var RedemptionBy = [
    { title: "Units", value: "Units", rank: 1, disabled: false },
    { title: "Amount", value: "Amount", rank: 2, disabled: false },
];
export var notelist = [
    {
        listcontent: (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" }, "To cancel the transaction, kindly go to your UPI app, and reject the transaction request."))),
    },
    {
        listcontent: (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                "Get in touch",
                React.createElement("span", { className: "txt-midnight-blue txt-underline" }, "1800 - 102 - 3335"),
                "(8 AM - 5:30 PM)"))),
    },
    {
        listcontent: (React.createElement(React.Fragment, null,
            React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                "Email",
                React.createElement("span", { className: "txt-midnight-blue txt-underline ps-1" }, "helpdesk@nuvama.com")))),
    },
];
export var checkMultiplier = function (value, multiplier) {
    return value % multiplier != 0;
};
export var HoldingClientVsSchemeOutcomes = {
    D_DP: "D",
    P_DP: "P",
    DP_DP: "DP",
    DP_D: "D",
    DP_P: "P",
    D_D: "D",
    P_P: "P",
};
export var EClientTier;
(function (EClientTier) {
    EClientTier["DIAMOND"] = "diamond";
    EClientTier["BLACK"] = "black";
    EClientTier["PLATINUM"] = "platinum";
    EClientTier["GOLD"] = "gold";
    EClientTier["SILVER"] = "silver";
    EClientTier["BRONZE"] = "bronze";
    EClientTier["BLUE"] = "blue";
})(EClientTier || (EClientTier = {}));
export var clientTiericons = (_p = {},
    _p[EClientTier.DIAMOND] = diamond,
    _p[EClientTier.BLACK] = black,
    _p[EClientTier.PLATINUM] = platinum,
    _p[EClientTier.GOLD] = gold,
    _p[EClientTier.SILVER] = silver,
    _p[EClientTier.BRONZE] = bronze,
    _p[EClientTier.BLUE] = blue,
    _p);
export var generateClientTierIcon = function (tier) {
    if (tier) {
        return Object.keys(clientTiericons).includes(tier.toLowerCase())
            ? clientTiericons[tier.toLowerCase()]
            : undefined;
    }
};
export var SwitchFundsFilterSortList = [
    {
        name: "1 Year CAGR Returns - High to Low",
        value: ETransferFundsSortColumns.YEAR_1,
        type: ETransferFundsSortOrder.DESCENDING,
    },
    {
        name: "3 Year CAGR Returns - High to Low",
        value: ETransferFundsSortColumns.YEAR_3,
        type: ETransferFundsSortOrder.DESCENDING,
    },
    {
        name: "5 Year CAGR Returns - High to Low",
        value: ETransferFundsSortColumns.YEAR_5,
        type: ETransferFundsSortOrder.DESCENDING,
    },
    {
        name: "AUM - Highest to Lowest",
        value: ETransferFundsSortColumns.FUND_SIZE,
        type: ETransferFundsSortOrder.DESCENDING,
    },
];
export var defaultMutualFundsFilter = {
    amcName: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    category: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    rating: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    riskValue: {
        title: "",
        list: [],
        value: "",
        filterType: EMFFilterType.CHECKBOX,
    },
    schemeType: undefined,
    "1yCagr": undefined,
    "3yCagr": undefined,
    "5yCagr": undefined,
    expenseRatio: undefined,
    aumSize: undefined,
};
export var handleCheckIfSTPOrSwitchSearchOrFilterApplied = function (object, includeSearchAsFilter) {
    if (includeSearchAsFilter === void 0) { includeSearchAsFilter = false; }
    var allFilterSearchKeys = __spreadArray([
        "amcName",
        "benchmark",
        "expenseRatio",
        "fundSize",
        "rating",
        "riskValue",
        "schPlan",
        "schType",
        "schemeCode",
        "subCatCode",
        "year1",
        "year3",
        "year5"
    ], __read((includeSearchAsFilter && [
        "searchText",
    ])), false);
    return allFilterSearchKeys.some(function (key) {
        if (key === "subCatCode" &&
            Object.prototype.hasOwnProperty.call(object, key)) {
            if (object[key].includes("11") &&
                object[key].length === 1) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return Object.prototype.hasOwnProperty.call(object, key);
        }
    });
};
